import $ from 'jquery';

var Mnav = {

    init: function() {
        $('.js-toggle-mnav').on('click', function(e) {
            e.preventDefault();
            var id = $(this).data('target');
            var $target = $('#' + id);
            $('.mnav__content:not(#' + id + ')').removeClass('mnav__content--open');
            $('.mnav__link').not(this).removeClass('mnav__link--active');

            $target.toggleClass('mnav__content--open');
            $(this).toggleClass('mnav__link--active', $target.hasClass('mnav__content--open'));
        });

        $('.js-close-mnav').on('click', function(e) {
            e.preventDefault();
            $('.mnav__content').removeClass('mnav__content--open');
            $('.mnav__link').removeClass('mnav__link--active');
        })
    }

}

export default Mnav;